<button
    class="ba-btn ba-btn-{{ buttonStyleType }} {{ styleClass }}"
    [id]="id + '_btn'"
    (click)="onClick($event)"
    [attr.aria-label]="ariaLabel"
    [ngClass]="{ 'ba-loading ba-loading-small': isDisabled }"
    [disabled]="isDisabled"
    type="button"
>
    <ng-content></ng-content>
</button>
